export function moreInfo() {
	const contMore = document.getElementById('moreInfoCont');
	const btnMore = document.getElementById('moreInfoBtn');

	let isContentVisible = false;

	if (contMore && btnMore) {
		btnMore.addEventListener('click', () => {
			if (isContentVisible) {
				contMore.classList.add('hiddenMoreInfo');
			} else {
				contMore.classList.remove('hiddenMoreInfo');
				contMore.scrollIntoView({ behavior: 'smooth', block: 'end' });
			}

			isContentVisible = !isContentVisible;
			updateButtonText();
		});
	}

	function updateButtonText() {
		btnMore.textContent = isContentVisible ? 'Ver menos' : 'Ver más';
	}
}
